import { Stack } from "@mui/material";
import { AboutVersionLink } from "@WahooFitness/wahoo-offline-mfe";
import Copyright from "../About/Copyright";

function SettingsFooter() {
  return (
    <Stack mx={2} gap={1} alignItems="flex-start">
      <Copyright />
      <AboutVersionLink />
    </Stack>
  );
}

export default SettingsFooter;
